export const RECENTLY_VIEWED_STORAGE_KEY = 'miRecentlyViewedProperties';
export const RETARGETING_ELIGIBILITY_WINDOW_14_DAYS_MS = 14 * 24 * 60 * 60 * 1000;
export const HOMEPAGE_HWS_RLM_USE_CASE = 'hws-rlm' as const;

export const HOMEPAGE_RETARGETING_IMAGE_FALLBACK =
  'https://cache.marriott.com/is/image/marriotts7prod/mi-photo-coming-soon:Square';
export const HOMEPAGE_RETARGETING_BADGE_TEXT = 'Recently Viewed';
export const HOMEPAGE_RETARGETING_BADGE_ICON = 'marriott-icons:icon-clock';
export const HOMEPAGE_RETARGETING_DESCRIPTION = 'Pick up where you left off! Continue exploring this property.';

export const RETARGETING_PRIMARY_IMAGE_FAILED_EVENT = '[HOMEPAGE][RETARGETING][PRIMARY_IMAGE_FAILED]';
export const RETARGETING_RECENTLY_VIEWED_JSON_INVALID_EVENT = '[HOMEPAGE][RETARGETING][RECENTLY_VIEWED_JSON_INVALID]';
export const RETARGETING_RECENTLY_VIEWED_STORAGE_ERROR_EVENT = '[HOMEPAGE][RETARGETING][RECENTLY_VIEWED_STORAGE_ERROR]';
export const RETARGETING_RECENTLY_VIEWED_STORAGE_INVALID_EVENT =
  '[HOMEPAGE][RETARGETING][RECENTLY_VIEWED_STORAGE_INVALID]';
export const RETARGETING_RECENTLY_VIEWED_CANDIDATES_INVALID_EVENT =
  '[HOMEPAGE][RETARGETING][RECENTLY_VIEWED_CANDIDATES_INVALID]';
export const RETARGETING_RESLINK_STORAGE_INVALID_EVENT = '[HOMEPAGE][RETARGETING][RESLINK_STORAGE_INVALID]';
export const RETARGETING_RESLINK_STORAGE_ACCESS_ERROR_EVENT = '[HOMEPAGE][RETARGETING][RESLINK_STORAGE_ACCESS_ERROR]';
export const RETARGETING_RESLINK_CANDIDATES_INVALID_EVENT = '[HOMEPAGE][RETARGETING][RESLINK_CANDIDATES_INVALID]';
export const RETARGETING_CANDIDATE_READER_ERROR_EVENT = '[HOMEPAGE][RETARGETING][CANDIDATE_READER_ERROR]';
export const RETARGETING_RLM_INVALID_DATES_SKIP_EVENT = '[HOMEPAGE][RETARGETING][RLM_INVALID_DATES_SKIP]';
export const RETARGETING_SLOT_RENDER_ERROR_EVENT = '[HOMEPAGE][RETARGETING][SLOT_RENDER_ERROR]';
export const RETARGETING_FALLBACK_RENDER_ERROR_EVENT = '[HOMEPAGE][RETARGETING][FALLBACK_RENDER_ERROR]';
